"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uri_1 = require("../../../shared/uri");
var baseServiceUri_1 = require("../baseServiceUri");
var objectToQuery_1 = require("../../../shared/objectToQuery");
var RequestConfigBuilder = /** @class */ (function () {
    function RequestConfigBuilder(_a) {
        var model = _a.model, projectName = _a.projectName, fetchConfig = _a.fetchConfig;
        this.projectName = projectName;
        this.model = model;
        this.fetchConfig = fetchConfig;
    }
    RequestConfigBuilder.prototype.build = function () {
        var _a = this.model, microserviceName = _a.microserviceName, hostType = _a.hostType;
        var baseServiceUri = baseServiceUri_1.getBaseServiceUri(microserviceName, this.projectName, hostType);
        var parameters = this.getParameters();
        return this.getConfig(parameters, baseServiceUri);
    };
    RequestConfigBuilder.prototype.getParameters = function () {
        var _a = this.model, method = _a.method, parameters = _a.parameters;
        var _b = this.fetchConfig, transformBodyToLegacyString = _b.transformBodyToLegacyString, bodyAsEncodeString = _b.bodyAsEncodeString;
        if (method === 'GET' || bodyAsEncodeString) {
            return objectToQuery_1.transformObjectToQuery(parameters, transformBodyToLegacyString);
        }
        return JSON.stringify(parameters);
    };
    RequestConfigBuilder.prototype.getConfig = function (parameters, baseServiceUri) {
        var _a = this.model, method = _a.method, pathApi = _a.pathApi;
        var _b = this.fetchConfig, subdomain = _b.subdomain, _c = _b.requestConfig, requestConfig = _c === void 0 ? {} : _c;
        var headers = requestConfig.headers, withCredentials = requestConfig.withCredentials;
        return {
            body: method === 'GET' ? undefined : parameters,
            method: method,
            uri: uri_1.mergeBaseUri(baseServiceUri, {
                // Это deprecated API, для некоторых старых апишек нужно указывать субдомен
                host: subdomain && subdomain.length ? function (host) { return subdomain + "." + host; } : undefined,
                path: function (path) { return uri_1.mergePaths(path, pathApi); },
                query: method === 'GET' ? parameters : undefined,
            }),
            withCredentials: typeof withCredentials === 'undefined' || withCredentials,
            headers: headers,
        };
    };
    return RequestConfigBuilder;
}());
exports.RequestConfigBuilder = RequestConfigBuilder;
//# sourceMappingURL=requestConfigBuilder.js.map